import AuthModalContentLoginStepsOriginRenderer from './OriginRenderer';

export default function AuthModalContentLoginSteps() {
  return <AuthModalContentLoginStepsOriginRenderer />;
}
